const ROOT = ['root']
const AdminRole = ['root','admin']
const User = ['user', 'admin','root']

export { ROOT, AdminRole, User }